/**
 * The only module that reads `import.meta.env`. Missing Supabase values are not
 * thrown here, so pages that need no data still render; lib/supabase.ts
 * enforces them when the client is first used.
 */
export const env = {
  supabaseUrl: import.meta.env.VITE_SUPABASE_URL ?? '',
  supabaseAnonKey: import.meta.env.VITE_SUPABASE_ANON_KEY ?? '',
  /** Absolute origin without a trailing slash, or '' when not configured. */
  siteUrl: (import.meta.env.VITE_SITE_URL ?? '').replace(/\/+$/, ''),
  isDev: import.meta.env.DEV,
  /**
   * Supabase image transformations (a paid feature). On, vehicle photos are
   * served resized; off, the originals are used untouched.
   */
  supabaseImageTransforms: import.meta.env.VITE_SUPABASE_IMAGE_TRANSFORMS === 'true',
  /**
   * Cloudflare Turnstile site key. Public by design (it is embedded in every
   * page); the secret lives only in the Supabase function secrets. Empty means
   * forms cannot submit, which is deliberate: see lib/turnstile.ts.
   */
  turnstileSiteKey: import.meta.env.VITE_TURNSTILE_SITE_KEY ?? '',
  /** Dev-only sample enquiries, orders and tax data (not vehicles); a production build refuses to run with this on. */
  useMockData: import.meta.env.VITE_USE_MOCK_DATA === 'true',
} as const;
